import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, CheckCircle, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import './HowItWorksPage.css';

// Rutas de imágenes desde la carpeta public
const img1 = '/Imagenes_rtb/1.png';
const img2 = '/Imagenes_rtb/2.png';
const img3 = '/Imagenes_rtb/3.png';
const img4 = '/Imagenes_rtb/4.png';
const img5 = '/Imagenes_rtb/5.png';
const img6 = '/Imagenes_rtb/6.heic';
const img7 = '/Imagenes_rtb/7.png';
const img8 = '/Imagenes_rtb/8.png';
const img9 = '/Imagenes_rtb/12.png';

export default function HowItWorksPage() {
  const [currentStep, setCurrentStep] = useState(0);

  const steps = [
    {
      image: img1,
      title: 'Paso 1: Regístrate en la Plataforma',
      description: 'Crea tu cuenta de forma rápida y segura. Es completamente GRATIS y solo toma 2 minutos.',
      details: [
        '📧 Ingresa tu correo electrónico (aquí te llegarán todas las alertas)',
        '🔒 Crea una contraseña segura (mínimo 6 caracteres)',
        '👤 Elige un nombre de usuario único',
        
        '🎉 ¡Listo! Ya tienes acceso a tu panel personal'
      ]
    },
    {
      image: img2,
      title: 'Paso 2: Configura tu Monitoreo',
      description: 'Dile a la plataforma qué partidos te interesan. Puedes seguir tantos como quieras y permita tu plan.',
      details: [
        '⚽ Selecciona los partidos que te interesen.',
        '🔔 Configura qué tipo de notificaciones quieres recibir',
        '💾 Guarda tus preferencias (se recordarán automáticamente)'
      ]
    },
    {
      image: img3,
      title: 'Paso 3: Recibe Notificaciones Instantáneas',
      description: 'Nunca más te pierdas de una oportunidad importante. Recibe alertas instantáneas en tu correo.',
      details: [
        '📧 Alertas por correo electrónico (revisa tu bandeja de entrada y SPAM)',
        '⚡ Actualizaciones de precio de cada coleccionable',
        '📊 Recibe resúmenes de todos los coleccionables'
      ]
    },
    {
      image: img4,
      title: 'Paso 4: Establece tus umbrales de precio',
      description: 'Define el precio del que debe bajar el coleccionable para recibir alertas.',
      details: [

        '⚖️ Comparativas entre precios actual y tu umbral',
        '📋 Monitorea los precios de todos los coleccionables',
      ]
    },
    {
      image: img5,
      title: 'Paso 5: Utiliza un cupón de descuento',
      description: 'Usa el cupón de tu influencer favorito y recibe un 10% de descuento en tu plan.',
      details: [
        '👥 Escribe el código de tu influencer favorito',
        '🎁 Recibe un 10% de descuento en tu plan',
      ]
    },
    {
      image: img6,
      title: 'Paso 6: Confirma tu compra.',
      description: 'Paga con tu método de pago favorito.',
      details: [
        '🌍 Utiliza el método de tu preferencia',
      ]
    },
    {
      image: img7,
      title: 'Paso 7: Revisa tu Dashboard de Resumen',
      description: 'Accede a tu panel principal donde verás todas las estadísticas de tu monitoreo en tiempo real.',
      details: [
        '🏟️ Ve cuántos partidos tienes monitoreados actualmente',
        '🔔 Revisa el total de alertas que has recibido',
        '⚡ Consulta la frecuencia de monitoreo configurada',
        
        '📊 Accede a la tabla completa de partidos disponibles (sólo para usuarios premium y élite)'
      ]
    },
    {
      image: img8,
      title: 'Paso 8: Gestiona tu Pestaña de Monitoreo',
      description: 'Accede a la pestaña de monitoreo para gestionar todos tus partidos y configurar alertas personalizadas.',
      details: [
        '📊 Ve todos tus partidos monitoreados en tarjetas individuales',
        '🔔 Configura umbrales de precio para cada partido específico',
        '⚙️ Ajusta la frecuencia de monitoreo (cada 15, 30, 60 minutos)',
        '📈 Revisa estadísticas detalladas de cada partido monitoreado',
        '➕ Agrega o elimina partidos de tu lista de monitoreo'
      ]
    },
    {
      image: img9,
      title: 'Paso 9: Recibe Alertas Directo en tu Correo',
      description: 'Cuando un coleccionable alcance el precio que te interesa, te enviaremos un correo electrónico con todos los detalles para que no pierdas la oportunidad.',
      details: [
        '📧 Notificación instantánea en tu correo electrónico registrado',
        '📈 Detalles claros: precio actual, umbral objetivo y oportunidad de ganancia',
        '⚽ Información completa del partido: equipos, ronda, estadio y fecha',
        '🔗 Botón directo "VER EN MARKETPLACE" para actuar inmediatamente',
        '⏰ Alertas en tiempo real para que estés siempre un paso adelante'
      ]
    }
  ];

  const nextStep = () => {
    setCurrentStep((prev) => (prev + 1) % steps.length);
  };

  const prevStep = () => {
    setCurrentStep((prev) => (prev - 1 + steps.length) % steps.length);
  };

  const goToStep = (stepIndex) => {
    setCurrentStep(stepIndex);
  };

  return (
    <div className="how-it-works-page">
      <div className="how-it-works-container">
        <header className="how-it-works-header">
          <div className="header-content">
            <Link to="/login" className="back-button">
              <ArrowLeft size={20} />
              Volver al Login
            </Link>
            <Logo size="header-logo" className="header-logo" />
          </div>
          <div className="header-text">
            <h1>¿Cómo Funciona?</h1>
            <p>Descubre cómo monitorear el fútbol nunca fue tan fácil</p>
          </div>
        </header>

        <main className="how-it-works-main">
          <div className="step-content-wrapper">
            <div className="step-image-section">
              <div className={`step-image-container ${currentStep === 8 ? 'vertical-image' : ''}`}>
                <img 
                  src={steps[currentStep].image} 
                  alt={steps[currentStep].title}
                  className="step-image"
                />
                <div className="step-number">
                  {currentStep + 1} / {steps.length}
                </div>
              </div>
            </div>

            <div className="step-info-section">
              <div className="step-content">
                <h2 className="step-title">{steps[currentStep].title}</h2>
                <p className="step-description">{steps[currentStep].description}</p>
                
                <div className="step-details">
                  {steps[currentStep].details.map((detail, index) => (
                    <div key={index} className="detail-item">
                      <CheckCircle size={20} className="detail-icon" />
                      <span>{detail}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="step-navigation">
            <button 
              className="nav-button prev-button" 
              onClick={prevStep}
              disabled={currentStep === 0}
            >
              <ChevronLeft size={20} />
              Anterior
            </button>

            <div className="step-indicators">
              {steps.map((_, index) => (
                <button
                  key={index}
                  className={`step-indicator ${index === currentStep ? 'active' : ''}`}
                  onClick={() => goToStep(index)}
                />
              ))}
            </div>

            <button 
              className="nav-button next-button" 
              onClick={nextStep}
              disabled={currentStep === steps.length - 1}
            >
              Siguiente
              <ChevronRight size={20} />
            </button>
          </div>
        </main>

        <footer className="how-it-works-footer">
          <Link to="/register" className="btn btn-primary start-button">
            ¡Comenzar Ahora!
          </Link>
        </footer>
      </div>
    </div>
  );
}
